import { CreateObraServicosControladosRequest } from "../../../data/daos/create/create_obra_servicos_controlados";
import { ICreateObraServicosControladosUseCase } from "../../../presentation/useCases/create/create_obra_servicos_controlados_use_case";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * CreateObraServicosControladosUseCase
 */
export class CreateObraServicosControladosUseCase implements ICreateObraServicosControladosUseCase {
  constructor(private readonly repository: IObrasRepository) {}

  async createObraServicosControlados(model: CreateObraServicosControladosRequest): Promise<void> {
    await this.repository.postObraServicosControladosCreate(model);
  }
}
